import { Component, OnDestroy, OnInit, effect, signal } from '@angular/core';
import { AppSettings } from '../_helpers/app.settings';
import { CreateCustomerComponent } from './create-customer/create-customer.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { MatTableDataSource } from '@angular/material/table';
import { LicensingService } from './licensing.service';
import { ConfirmDialogComponent, ConfirmDialogModel } from '../_helpers/confirm-dialog/confirm-dialog.component';
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { NotificationService } from '../_helpers/notification.service';
import { AppMessages } from '../_helpers/app.messages';
import { ViewCustomerComponent } from './view-customer/view-customer.component';
import { TokenStorageService } from '../_helpers/token-storage.service';
import { HelperService } from '../_helpers/helper.service';
import { Observable, Subject, debounceTime, distinctUntilChanged, switchMap } from 'rxjs';
@Component({
  selector: 'app-licensing',
  templateUrl: './licensing.component.html',
  styleUrls: ['./licensing.component.scss']
})
export class LicensingComponent implements OnInit, OnDestroy{
  AppSettings = AppSettings;
  title: string = '';
  icon: string = '';
  licensingMenuItem: any = '';
  columns: any = [];
  data: any = [];
  controls: any = [];
  filterBy: any;
  filterByList: any = [];
  dataSource: any = [];
  totalRec: number = 0;
  signalTest = signal('value1');
  pagination: any = {
    pageIndex: 0,
    pageSize: 10
  }
  searchValue: any = '';
  sort: any = {};
  userRole: string = '';
  resetData: boolean = false;
  private searchSub = new Subject<string>();

  constructor(
    private modalService: BsModalService,
    private createCustomerModalRef: BsModalRef,
    private licensingService: LicensingService,
    public dialog: MatDialog,
    private notificationService: NotificationService,
    private tokenStorageService: TokenStorageService,
    private helperService: HelperService
  ) {
    this.licensingMenuItem = AppSettings.MAIN_MENU_ITEMS?.find((rec) => {
      return rec.name?.toLocaleLowerCase() == 'licensing';
    });
    if(this.licensingMenuItem) {
      this.title = this.licensingMenuItem.title;
      this.icon = this.licensingMenuItem.icon;
    }
    this.columns = [...AppSettings.LICENSING_TABLE_COLUMNS];
    this.filterByList = AppSettings.licenseFilterOptions;
    this.filterBy = 'all';
    effect(() => console.log(this.signalTest()));
  }
  ngOnInit(): void {
    this.userRole = this.tokenStorageService.getUserRole();
    this.initControlButtons();
    this.initSearch();
    this.fetchData();
    // this.signalTest.set("value2");
    
  }
  initControlButtons() {
    let actions = AppSettings.USER_ROLE_ACTION_MAP[AppSettings.MODULES.LICENSING as keyof object][AppSettings.USER_ROLES[this.userRole as keyof object]];
    let conditions: any = {};
    if(this.helperService.contains(actions, AppSettings.ACTIONS.DELETE)) {
      conditions[AppSettings.ACTIONS.DELETE] = {"disabledField": "isActive"};
    }
    if(this.helperService.contains(actions, AppSettings.ACTIONS.DOWNLOAD)) {
      conditions[AppSettings.ACTIONS.DOWNLOAD] = {"disabledField": "isActiveDownload"};
    }
    
    this.helperService.getControlButtons(AppSettings.MODULES.LICENSING, this.userRole, [AppSettings.CREATE], this.controls, conditions);
  }
  initSearch() {
    this.searchSub.pipe(debounceTime(AppSettings.DEBOUNCING_TIME)).subscribe(() => {
      this.applyFilter();
    });
  }
  fetchData() {
    this.resetData = false;
    this.helperService.showLoader(true);
    let data: any = {
      "pageNo": this.pagination.pageIndex,
      "pageSize": this.pagination.pageSize,
      "searchItem": this.searchValue,
      "sortField": this.sort?.sortColumnName,
      "sortBy": this.sort?.type,
      "filterByLicenseType": this.filterBy
    };
    this.licensingService.fetchLicenses({
      data: data,
      success: (response: any) => {
        if(response && response.data) {
          console.log(response.data);
          if(!response.data.length) {
            this.resetData = true;
          }
          this.dataSource = this.processData(response.data);
          this.totalRec = response.totalRecords;
          this.helperService.showLoader(false);
        }
      },
      error: (error: any) => {
        this.helperService.showLoader(false);
        console.log(error);
      }
    });

  }
  
  pageChange() {
    if(this.dataSource?.length == 1) {
      this.pagination.pageIndex = 0;
    }
  }
  processData(data: any): any {
    if(!data?.length) {
      return [];
    }
    let disabled = !this.helperService.isActionAllowed(AppSettings.MODULES.LICENSING, AppSettings.ACTIONS.EDIT);
    data = data.map((rec:any) => {
      rec.licenseType = rec.isPaidLicense ? "Paid": "Trial";
      rec.checked = rec.isActive;
      rec.startDate = this.helperService.convert(rec.startDate, AppSettings.DD_MM_YYYY);
      rec.endDate = this.helperService.convert(rec.endDate, AppSettings.DD_MM_YYYY);
      rec.controls = 'controls';
      rec.disabled = disabled;
      rec.isActiveDownload = !rec.isActive;
      return rec;
    });
    return data;
  }
  onControlButtonClick(event: any) {
    console.log(event);
    let action = event?.action;
    switch(action) {
      case AppSettings.VIEW:
        this.onViewClick(event);
        break;
      case AppSettings.DOWNLOAD:
        this.onDownloadClick(event);
        break;
      case AppSettings.EDIT:
        this.onEditClick(event);
        break;
      case AppSettings.DELETE:
        this.onDeleteClick(event);
        break;
    }
  }
  onViewClick(e: any) {
    let modelObj = {customerCode: e?.data?.customerCode};
    this.createCustomerModalRef = this.modalService.show(ViewCustomerComponent, {
      initialState: {
        model: modelObj,
      },
      class: 'modal-lg',
      backdrop: true,
      ignoreBackdropClick: true,
    });
  }
  onDownloadClick(e: any) {
    if(!this.helperService.isActionAllowed(AppSettings.MODULES.LICENSING, AppSettings.ACTIONS.DOWNLOAD)) {
      return;
    }
    this.helperService.showLoader(true);
    let data = {
      customerCode: e?.data?.customerCode
    };
    let fileName = e?.data?.customerCode || 'license';
    fileName = `${fileName}.QE360license`;
    this.licensingService.downloadLicense({
      data: data,
      success: (data: any) => {
        var downloadURL = window.URL.createObjectURL(data);
        var link = document.createElement('a');
        link.href = downloadURL;
        link.download = `${fileName}`;
        link.click();
        this.notificationService.showSuccess(AppMessages.DOWNLOAD_SUCCESS);
        this.helperService.showLoader(false);

      },
      error: (error: any) => {
        this.notificationService.showError(error.errorMessage);
        console.log(error);
        this.helperService.showLoader(false);

      }
    });
  }
  onEditClick(e: any) {
    if(!this.helperService.isActionAllowed(AppSettings.MODULES.LICENSING, AppSettings.ACTIONS.EDIT)) {
      return;
    }
    let modelObj = {isEdit: true, customerCode: e?.data?.customerCode};
    this.createCustomerModalRef = this.modalService.show(CreateCustomerComponent, {
      initialState: {
        initialData: modelObj,
      },
      class: 'modal-lg',
      backdrop: true,
      ignoreBackdropClick: true,
    });
    this.createCustomerModalRef.content.updateList.subscribe((res: any) => {
      this.fetchData();
    });
  }
  onDeleteClick(e: any) {
    if(!this.helperService.isActionAllowed(AppSettings.MODULES.LICENSING, AppSettings.ACTIONS.DELETE)) {
      return;
    }
    let item = e?.data?.customerCode || '';
    const message = `Are you sure you want to delete the <b>${item}</b> customer?`;
    const icon = 'trash';

    const dialogData = new ConfirmDialogModel("Delete Confirmation", message, icon);

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "600px",
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      let data = {
        customerCode: e?.data?.customerCode
      };
      if(dialogResult) {
        this.helperService.showLoader(true);
        this.licensingService.deleteLicense({
          data: data,
          success: (response: any) => {
            this.notificationService.showSuccess(response.message);
            this.helperService.showLoader(false);
            this.pageChange();
            this.fetchData();
          },
          error: (error: any) => {
            console.log(error);
            this.notificationService.showError(error.errorMessage);
            this.helperService.showLoader(false);
          }
        });
      } else {
        this.helperService.showLoader(false);
      }
    });
  }
  onCreateNewClick() {
    if(!this.helperService.isActionAllowed(AppSettings.MODULES.LICENSING, AppSettings.ACTIONS.CREATE)) {
      return;
    }
    let modelObj = {};
    this.createCustomerModalRef = this.modalService.show(CreateCustomerComponent, {
      initialState: {
        // item: modelObj,
      },
      class: 'modal-lg',
      backdrop: true,
      ignoreBackdropClick: true,
    });
    this.createCustomerModalRef.content.updateList.subscribe((res: any) => {
      this.fetchData();
    });
  }
  applyFilter() {
    this.resetPagination();
    this.fetchData();
  }
  onSearch(e: any) {
    this.searchSub.next(this.searchValue);
  }
  onSortStateChange(e: any) {
    console.log(e);
    this.sort = e;
    this.resetPagination();
    this.fetchData();
  }
  onFilterByChange(e: any) {
    this.resetPagination();
    this.fetchData();
  }
  resetPagination() {
    this.pagination.pageIndex = 0;
  }
  onPageChange(e: any) {
    console.log(e);
    this.pagination = e;
    this.fetchData();
    
  }
  onButtonClick(e: any) {
    this.helperService.showLoader(true);
    let data = {
      customerCode: e.data.customerCode
    };
    // let data = {
    //   page: 2
    // }
    this.licensingService.toggleLicense({
      data: data,
      success: (response: any) => {
       this.notificationService.showSuccess(response.message);
        this.helperService.showLoader(false);
        this.fetchData();
      },
      error: (error: any) => {
        console.log(error);
        this.notificationService.showError(error.errorMessage);
        this.helperService.showLoader(false);
        this.fetchData();
      }
    });
    
    
  }
  ngOnDestroy() {
    this.searchSub.complete();
  }
}
